import React from "react";
import { Modal, Checkbox } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const DeactivateClientModal = ({
  visible,
  onOk,
  onCancel,
  clientData,
  notifyClient,
  setNotifyClient,
  emailContent,
  setEmailContent,
}) => {
  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      closable={false}
      footer={null}
      centered
    >
      <h3 className="modaltitle">Deactivate Client</h3>
      <h4 className="inputTitle">
        You are about to make <strong style={{ color: "black" }}>{clientData && clientData.name}</strong>{" "}
        inactive. This will suspend portal access and pause all data refreshes.
        The active seat will enter a 24-hour cooldown.
      </h4>

      <div style={{ marginTop: 20, marginBottom: 10 }}>
        <Checkbox
          checked={notifyClient}
          onChange={(e) => setNotifyClient(e.target.checked)}
        >
          Notify client
        </Checkbox>
      </div>

      {notifyClient && (
        <div style={{ marginTop: 10 }}>
          <p style={{ marginBottom: 5, fontWeight: 500 }}>Email Template:</p>
          <ReactQuill
            theme="snow"
            value={emailContent}
            onChange={(content) => setEmailContent(content)}
            style={{
              height: "200px",
              marginBottom: "50px"
            }}
          />
        </div>
      )}
      <div className="buttonsMain">
        <button
          className={"savebutton"}
          style={{background:"#E13C25"}}
          onClick={() => {
            onOk();
          }}
        >
          Deactivate
        </button>
        <button
          className="cancelbutton"
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeactivateClientModal;
